import { customToast } from "../../lib/toastLib";
import { clearCookieData } from "../../utils";

const logoutApi = async () => {
  try {
    localStorage.removeItem("lastLoginDate");
    await clearCookieData();
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
  } finally {
    window.location.reload();
  }
};

export default logoutApi;
